module.exports = __webpack_public_path__ + "static/media/chat.42a6182.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat.mp3
// module id = 2otd
// module chunks = 3